<script>
import MainTabs from "@/components/helpers/MainTabs.vue";
import HistoryOperationsTab from "@/modules/international-operations/components/HistoryOperationsTab.vue";
import StatisticsTab from "@/modules/international-operations/components/StatisticsTab.vue";
import ReferralLinksTab from "@/modules/international-operations/components/ReferralLinksTab.vue";

export default {
  name: "InternationalOperations",
  components: {
    MainTabs,
    HistoryOperationsTab,
    StatisticsTab,
    ReferralLinksTab,
  },

  props: {
    currentCountry: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedTab: {
        id: "history-operations",
        title: "История операций",
        icon: "icon-history-operations",
      },

      TABS: [
        {
          id: "history-operations",
          title: "История операций",
          icon: "icon-history-operations",
        },
        {
          id: "statistics",
          title: "Статистика",
          icon: "icon-statistics",
        },
        {
          id: "referral-links",
          title: "Реферальные ссылки",
          icon: "icon-referral-links",
        },
      ],
    };
  },

  computed: {
    currentTab() {
      switch (this.selectedTab.id) {
        case "history-operations":
          return HistoryOperationsTab;

        case "statistics":
          return StatisticsTab;

        case "referral-links":
          return ReferralLinksTab;

        default:
          return HistoryOperationsTab;
      }
    },

    componentKey() {
      return `${this.selectedTab.id}-${this.currentCountry}`;
    },
  },

  methods: {
    updateTabHandler(tabInfo) {
      localStorage.setItem("internationalOperationsTab", tabInfo.id);
    },
  },

  created() {
    const savedTab = localStorage.getItem("internationalOperationsTab");

    if (savedTab) {
      this.selectedTab = this.TABS.find((tab) => tab.id === savedTab);
    }
  },
};
</script>

<template>
  <div class="tabs-info">
    <MainTabs
      :selected-tab.sync="selectedTab"
      :tabs="TABS"
      @update:selectedTab="updateTabHandler"
    />

    <component
      :is="currentTab"
      :key="componentKey"
      :current-country="currentCountry"
    />
  </div>
</template>

<style lang="scss" scoped>
.tabs-info {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
